let touched = false;

export default function isTouch() {
  return touched;
}

function wasTouched() {
  window.theme.touched = true;
  touched = true;
  document.removeEventListener('touchstart', wasTouched, {passive: true});
  document.documentElement.className = document.documentElement.className.replace('no-touch', 'touch');
  document.dispatchEvent(
    new CustomEvent('theme:touch', {
      bubbles: true,
    })
  );
}

document.addEventListener('touchstart', wasTouched, {passive: true});
